import { useRef, useState } from "react";
import axios from "axios";
import useSWR from "swr";
import { useToast } from "./useToast";

const NOTIFY_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "/notify/api/v1"
    : "https://api.mixfiscal.com.br/notify/api/v1";

export const useNotifyAPIAuthenticate = () => {
  const onRejected = error => {
    return Promise.reject(error);
  };

  const apiRef = useRef(
    axios.create({
      baseURL: NOTIFY_BASE_URL,
      withCredentials: false,
    }),
  );

  apiRef.current.interceptors.request.use(config => {
    config.headers = {
      Authorization: "Bearer @MASTER20232312199542312",
      "Content-Type": "application/json;charset=utf-8",
    };
    return config;
  });

  apiRef.current.interceptors.response.use(response => response, onRejected);

  return apiRef.current;
};

export const useAPINotifyToast = () => {
  const [isLoading, setIsLoading] = useState(false);
  const api = useNotifyAPIAuthenticate();
  const { addToast } = useToast();

  const onSend = async ({
    messageSuccess,
    messageFail,
    endpoint,
    type = "POST",
    data: dataFields = {},
  }) => {
    try {
      setIsLoading(true);
      const { data } = await api({
        method: type,
        url: endpoint,
        data: dataFields,
      });

      if (data.response ?? data.success) {
        addToast({
          type: "success",
          title: "SUCESSO",
          description: messageSuccess,
        });
      }
      setIsLoading(false);
      return data;
    } catch (err) {
      const messageFailRequest = err?.response?.data?.message;
      console.error(
        "[useAPINotifyToast] error:",
        err?.response?.status,
        err?.response?.data,
      );

      addToast({
        type: "error",
        title: "FALHA",
        description: messageFail ?? messageFailRequest,
      });
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    onSend,
  };
};

export const useFetchNotify = (url, axiosConfigs, config) => {
  const api = useNotifyAPIAuthenticate();

  const { data, error, mutate, isValidating } = useSWR(
    url,
    async urlReturn => {
      const response = await api.get(urlReturn, axiosConfigs);
      return response.data;
    },
    config,
  );

  return {
    data,
    error,
    isError: !!error,
    isLoading: (!error && !data && String(data) !== "") || isValidating,
    isValidating,
    mutate,
  };
};
